<template>
  <v-dialog :value="value"
            max-width="600">
    <v-form v-model="validForm">
      <v-card>
        <v-container fluid>
          <v-card-title>
            Spendenbarometer {{ collection.name }}
          </v-card-title>
          <v-card-subtitle>
            Hier können Sie das Spendenbarometer für Ihre Organisation konfigurieren.
          </v-card-subtitle>
          <v-card-text class="d-flex align-end ">
          <span class="mr-3 text-center">
            Was ist das Spendenziel?
          </span>
            <CurrencyInput
              class="my-0 py-0"
              style="max-width:130px;"
              hide-details
              dense
              placeholder="10.000,00"
              v-model="form.goalCents"
            />
          </v-card-text>
          <v-card-text>
            Auf welcher Domain möchten Sie das Spendenbarometer einsetzen? Zum Beispiel auf der Website Ihrer
            Organisation oder eines Projektes:
            <v-combobox
              v-model="form.allowed_origins"
              placeholder="z.B. https://www.meine-seite.de"
              multiple
              :rules="[
                value => {
                  if (!value?.length) return true
                  return value.every(domain => ORIGIN_REGEX.test(domain)) || 'Bitte einen korrekten \'Origin\' angeben, d.h. https://domain.de'
                }
            ]"
            >
              <template v-slot:selection="{ item }">
                <v-chip label
                >
                  <span>{{ item }}</span>
                </v-chip>

              </template>
            </v-combobox>
          </v-card-text>
          <v-card-actions>
            <v-btn color="red" text @click="confirm_delete_dialog= true"
                   v-if="!!secretToken"> löschen
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="$emit('close')"> Abbrechen</v-btn>
            <v-btn text @click="save" :disabled="!validForm"> Speichern</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-form>
    <v-dialog
      v-model="confirm_delete_dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Möchten Sie dieses Spendenbarometer wirklich löschen?
        </v-card-title>
        <v-card-text>Wenn Sie das Barometer jetzt löschen wird es nicht mehr verfügbar sein.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color=" darken-1"
            text
            @click="confirm_delete_dialog = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
            color="red"
            text
            @click="deleteDonationMeter"
          >
            löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-dialog>
</template>
<script>
import CurrencyInput from '@/components/CurrencyInput'
import {
  DELETE_DONATION_METER,
  FETCH_STATSENDPOINTS_FOR_COLLECTION_PLAN,
  SAVE_DONATION_METER
} from '@/store/action-types'
import { mapGetters } from 'vuex'

const ORIGIN_REGEX = /^(?:\*|(https?|wss?):\/\/(?:localhost|(?:[A-Za-z0-9-]{1,63}\.)*[A-Za-z0-9-]{1,63}|(?:\d{1,3}\.){3}\d{1,3}|\[[A-Fa-f0-9:.]+\])(?::\d{1,5})?)$/
const URL_SIMPLIFY_REGEX = /^\s*((?:https?:\/\/)?)([a-zA-Z0-9.:_-]+)\/?.*$/
const DEFAULT_GOAL = 10000
const WHITE_LIST_ORIGINS = [
  'https://spende.app',
  'https://digitalespende.de'
]

export default {
  emits: ['close'],
  props: {
    value: {
      type: Boolean,
      required: true
    },
    collection: {
      required: true
    }
  },
  components: {
    CurrencyInput
  },
  data: () => ({
    form: {
      goalCents: DEFAULT_GOAL * 100,
      allowed_origins: []
    },
    secretToken: null,
    validForm: false,
    confirm_delete_dialog: false,
    ORIGIN_REGEX,
  }),
  computed: {
    ...mapGetters('collectionPlan', ['statsendpointBySecretToken']),
  },
  methods: {
    async save () {
      await this.$store.dispatch('collectionPlan/' + SAVE_DONATION_METER, {
        collectionPlanUrl: this.collection.url,
        secretToken: this.secretToken,
        allowedOrigins: [...this.form.allowed_origins, ...WHITE_LIST_ORIGINS],
        meta: {
          donation_meter: {
            goal: this.form.goalCents / 100.0,
          }
        }
      })
      this.$emit('close')
    },
    async deleteDonationMeter () {
      await this.$store.dispatch('collectionPlan/' + DELETE_DONATION_METER, {
        collectionPlanUrl: this.collection.url,
        secretToken: this.secretToken
      })
      this.form = {
        goalCents: DEFAULT_GOAL * 100,
        allowed_origins: [],
      }
      this.secretToken = null
      this.$emit('close')
    }
  },
  async mounted () {
    // FIXME This doesn't update properly when opened after saving
    await this.$store.dispatch('collectionPlan/' + FETCH_STATSENDPOINTS_FOR_COLLECTION_PLAN, this.collection.url)
    if (this.collection?.meta?.donation_meter?.secret_token) {
      // Have previously saved a donation meter
      this.secretToken = this.collection?.meta?.donation_meter?.secret_token
      this.form = {
        goalCents: (this.collection?.meta?.donation_meter?.goal || DEFAULT_GOAL) * 100,
        allowed_origins: this.statsendpointBySecretToken[this.secretToken]?.allowed_origins?.filter(
          origin => !WHITE_LIST_ORIGINS.includes(origin)
        ) || []
      }
    } else {
      // Create new one
      this.secretToken = null
      this.form = {
        goalCents: DEFAULT_GOAL * 100,
        allowed_origins: []
      }
    }
  },
  watch: {
    "form.allowed_origins": function (newVal) {
      let changed = false
      const corrected = newVal.map(
        item => {
          if (!ORIGIN_REGEX.test(item)) {
            const match = URL_SIMPLIFY_REGEX.exec(item)
            if (match) {
              const changedVal = (match[1] || 'https://') + match[2]
              if (ORIGIN_REGEX.test(changedVal)) {
                changed = true
                return changedVal
              }
            }
          }
          return item
        }
      )
      if (changed) {
        this.$nextTick(() => { this.form.allowed_origins = corrected })
      }
    }
  }

}
</script>
<style lang="">

</style>
